import React from 'react';
import { Box, Container, Typography, Button, Stack, Grid } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import BusinessIcon from '@mui/icons-material/Business';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const stats = [
  { value: '25+', label: 'Yıllık tecrübe' },
  { value: 'KVKK', label: 'Uyum odaklı yaklaşım' },
  { value: '7/24', label: 'Süreç takibi' },
  { value: 'Kurumsal', label: 'Teknik danışmanlık' },
];

const Hero = () => {
  return (
    <Box
      sx={{
        color: 'white',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        pt: { xs: 12, md: 18 },
        pb: { xs: 8, md: 14 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 0.45,
          pointerEvents: 'none',
        }}
      >
        <source src="/videos/hero-bg.mp4" type="video/mp4" />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at top, rgba(95, 210, 255, 0.18) 0%, rgba(5, 8, 22, 0.02) 30%), linear-gradient(180deg, rgba(5, 8, 22, 0.08) 0%, rgba(5, 8, 22, 0.9) 82%, #050816 100%)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '-20%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: { xs: 520, md: 900 },
          height: { xs: 520, md: 900 },
          borderRadius: '50%',
          border: '1px solid rgba(146, 224, 255, 0.08)',
          boxShadow: '0 0 180px rgba(89, 208, 255, 0.18)',
        }}
      />

      <Container maxWidth="lg">
        <Stack
          spacing={4}
          sx={{ position: 'relative', zIndex: 2, textAlign: 'center', alignItems: 'center' }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 1.5,
              py: 0.9,
              borderRadius: 999,
              border: '1px solid rgba(255, 255, 255, 0.14)',
              bgcolor: 'rgba(255, 255, 255, 0.06)',
              backdropFilter: 'blur(14px)',
            }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                boxShadow: '0 0 18px rgba(89, 208, 255, 0.9)',
              }}
            />
            <Typography variant="body2" sx={{ color: 'rgba(248, 251, 255, 0.8)' }}>
              Uyum süreçlerinde
            </Typography>
            <Typography variant="body2" sx={{ color: 'white', fontWeight: 700 }}>
              teknik güvenlik odağı
            </Typography>
          </Box>

          <Box sx={{ maxWidth: 860 }}>
            <Typography
              component="h1"
              variant="h1"
              sx={{
                mb: 2.5,
                textWrap: 'balance',
                fontSize: { xs: 'clamp(2.5rem, 12vw, 3.8rem)', md: 'clamp(3rem, 6vw, 5.5rem)' },
                lineHeight: { xs: 0.98, md: 1.02 },
              }}
            >
              KVKK uyumunu
              <Box component="span" sx={{ display: 'block', color: 'rgba(248, 251, 255, 0.74)' }}>
                güçlü bilgi güvenliğiyle yönetin
              </Box>
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: 'rgba(228, 238, 248, 0.76)',
                lineHeight: 1.8,
                maxWidth: 760,
                mx: 'auto',
                fontWeight: 400,
                fontSize: { xs: '1rem', md: '1.25rem' },
              }}
            >
              GNC Veri Teknolojileri, işletmeler için KVKK uyum sürecini teknik denetim,
              kurumsal danışmanlık, eğitim ve sürdürülebilir bilgi güvenliği altyapısıyla
              birlikte ele alır.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
            <Button
              variant="contained"
              size="large"
              sx={{
                minWidth: 220,
                color: '#06111f',
                background: 'linear-gradient(180deg, #ffffff 0%, #dff6ff 100%)',
              }}
              startIcon={<SecurityIcon />}
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Hizmetleri İncele
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                minWidth: 220,
                borderColor: 'rgba(255, 255, 255, 0.18)',
                color: 'white',
                bgcolor: 'rgba(255,255,255,0.04)',
                backdropFilter: 'blur(14px)',
                '&:hover': {
                  borderColor: 'rgba(255, 255, 255, 0.32)',
                  bgcolor: 'rgba(255, 255, 255, 0.08)',
                },
              }}
              startIcon={<BusinessIcon />}
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              İletişime Geçin
            </Button>
          </Stack>

          <Box
            sx={{
              width: '100%',
              maxWidth: 760,
              mt: 2,
              p: { xs: 1.5, md: 2.5 },
              borderRadius: 999,
              border: '1px solid rgba(148, 163, 184, 0.14)',
              bgcolor: 'rgba(6, 17, 31, 0.52)',
              backdropFilter: 'blur(18px)',
            }}
          >
            <Grid container spacing={2}>
              {stats.map((stat) => (
                <Grid item xs={6} md={3} key={stat.label}>
                  <Typography sx={{ fontSize: { xs: '1.4rem', md: '1.8rem' }, fontWeight: 800 }}>
                    {stat.value}
                  </Typography>
                  <Typography sx={{ color: 'rgba(156, 179, 201, 0.86)', fontSize: '0.88rem' }}>
                    {stat.label}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Grid container spacing={2.2} sx={{ mt: { xs: 1, md: 3 }, maxWidth: 1080 }}>
            <Grid item xs={12} md={4}>
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1.25,
                  px: { xs: 1.5, md: 2.2 },
                  py: { xs: 1.25, md: 1.8 },
                  borderRadius: 5,
                  bgcolor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  backdropFilter: 'blur(14px)',
                  fontSize: { xs: '0.9rem', md: '1rem' },
                }}
              >
                <VerifiedUserIcon sx={{ color: 'primary.main' }} />
                Risk, envanter ve süreç yönetimi
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1.25,
                  px: { xs: 1.5, md: 2.2 },
                  py: { xs: 1.25, md: 1.8 },
                  borderRadius: 5,
                  bgcolor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  backdropFilter: 'blur(14px)',
                  fontSize: { xs: '0.9rem', md: '1rem' },
                }}
              >
                <AutoAwesomeIcon sx={{ color: 'primary.main' }} />
                Eğitim ve farkındalık programları
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1.25,
                  px: { xs: 1.5, md: 2.2 },
                  py: { xs: 1.25, md: 1.8 },
                  borderRadius: 5,
                  bgcolor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  backdropFilter: 'blur(14px)',
                  fontSize: { xs: '0.9rem', md: '1rem' },
                }}
              >
                <SecurityIcon sx={{ color: 'primary.main' }} />
                Uygulanabilir bilgi güvenliği mimarisi
              </Typography>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default Hero;
